// import { BX24 } from "bx24";
import axios from "axios";
import qs from "qs";
import moment from "moment";
import "moment/min/locales.min";
import "moment-timezone";
import BX24 from "./bx24";
import Helper from "../common/helper";

moment.locale('ru');

const bx24 = new BX24();
// const bx24 = null;
const urlParams = new URLSearchParams(window.location.search);
const baseUrl = `
    https://${urlParams.get("DOMAIN")}
`;
const isDev = /*(urlParams.get("DOMAIN") === null) ? true : */false;
const urlDev = 'https://185.20.224.69/rest/83/2prf7x2kfeqat51d/';

// if (!isDev) {
//     const bx24 = new BX24(window);
// }

export default class Bitrix24
{

    loadDeal(dealId)
    {
        return new Promise((resolve, reject) => {
            this.getConnect(isDev).then(connect => {

                let ajaxParams = {
                    id: dealId,
                };

                if (connect.auth) {
                    ajaxParams.auth = connect.auth.ACCESS_TOKEN;
                }
                // console.log(ajaxParams);
                // сохраняем
                axios({
                    method: "post",
                    url: connect.url + "crm.deal.get",
                    data: qs.stringify(ajaxParams,{ delimiter: '&'})
                }).then(result => {
                    resolve(result.data.result);
                });

            })
        })
    }

    loadDealProduct(dealId)
    {
        return new Promise((resolve, reject) => {
            this.getConnect(isDev).then(connect => {

                let ajaxParams = {
                    id: dealId,
                };

                if (connect.auth) {
                    ajaxParams.auth = connect.auth.ACCESS_TOKEN;
                }
                // console.log(ajaxParams);
                // сохраняем
                axios({
                    method: "post",
                    url: connect.url + "crm.deal.productrows.get",
                    data: qs.stringify(ajaxParams,{ delimiter: '&'})
                }).then(resultDealProduct => {

                    let dealProduct = resultDealProduct.data.result.map(item => {
                        return {
                            PRODUCT_ID: item.PRODUCT_ID,
                            CODE: null,
                            COMMENT: null,
                            COUNT: item.QUANTITY,
                            DELETE: false,
                            NAME: item.PRODUCT_NAME,
                            PRICE: item.PRICE,
                            QUANTITY: null,
                            STORE: null,
                            XML_ID: null,
                        }
                    })

                    let ajaxParams = {
                        filter: {ID: resultDealProduct.data.result.map(item => item.PRODUCT_ID)},
                        select: ["*", "PROPERTY_190"]
                    };

                    if (connect.auth) {
                        ajaxParams.auth = connect.auth.ACCESS_TOKEN;
                    }
                    // console.log(ajaxParams);
                    // сохраняем
                    axios({
                        method: "post",
                        url: connect.url + "crm.product.list",
                        data: qs.stringify(ajaxParams,{ delimiter: '&'})
                    }).then(resultProduct => {
                        resolve(dealProduct.map(item => {
                            return {
                                ...item,
                                XML_ID: resultProduct.data.result.find(product => parseInt(product.ID) === parseInt(item.PRODUCT_ID))?.XML_ID,
                                CODE: resultProduct.data.result.find(product => parseInt(product.ID) === parseInt(item.PRODUCT_ID))?.PROPERTY_190?.value
                            }
                        }));
                    })

                });

            })
        })
    }

    loadCompany(companyId)
    {
        return new Promise((resolve, reject) => {
            this.getConnect(isDev).then(connect => {

                let ajaxParams = {
                    id: companyId,
                };

                if (connect.auth) {
                    ajaxParams.auth = connect.auth.ACCESS_TOKEN;
                }
                // console.log(ajaxParams);
                // сохраняем
                axios({
                    method: "post",
                    url: connect.url + "crm.company.get",
                    data: qs.stringify(ajaxParams,{ delimiter: '&'})
                }).then(result => {
                    resolve(result.data.result);
                });

            })
        })
    }

    loadCompanySearch(search)
    {
        return new Promise((resolve, reject) => {
            this.getConnect(isDev).then(connect => {

                let ajaxParams = {
                    order: { "DATE_CREATE": "ASC" },
                    filter: { "%TITLE": search },
                    select: [ "ID", "TITLE", "CURRENCY_ID", "REVENUE", Helper.fields.COMPANY_XML, Helper.fields.COMPANY_ADDRESS]
                };

                if (connect.auth) {
                    ajaxParams.auth = connect.auth.ACCESS_TOKEN;
                }
                // console.log(ajaxParams);
                // сохраняем
                axios({
                    method: "post",
                    url: connect.url + "crm.company.list",
                    data: qs.stringify(ajaxParams,{ delimiter: '&'})
                }).then(result => {
                    resolve(result.data.result);
                });

            })
        })
    }

    loadDogovor(companyId)
    {
        return new Promise((resolve, reject) => {
            this.getConnect(isDev).then(connect => {

                let ajaxParams = {
                    IBLOCK_TYPE_ID: 'lists',
                    IBLOCK_ID: 28,
                    FILTER: {
                        PROPERTY_STATUS_DOGOVORA: [100, 102],
                        PROPERTY_KOMPANIYA: companyId
                    }
                };

                if (connect.auth) {
                    ajaxParams.auth = connect.auth.ACCESS_TOKEN;
                }
                // console.log(ajaxParams);
                // сохраняем
                axios({
                    method: "post",
                    url: connect.url + "lists.element.get",
                    data: qs.stringify(ajaxParams,{ delimiter: '&'})
                }).then(result => {
                    resolve(result.data.result);
                });

            })
        })
    }

    loadAddress(companyId)
    {
        return new Promise((resolve, reject) => {
            this.getConnect(isDev).then(connect => {

                let ajaxParams = {
                    IBLOCK_TYPE_ID: 'lists',
                    IBLOCK_ID: 32,
                    FILTER: {
                        PROPERTY_KOMPANIYA: companyId
                    }
                };

                if (connect.auth) {
                    ajaxParams.auth = connect.auth.ACCESS_TOKEN;
                }
                // console.log(ajaxParams);
                // сохраняем
                axios({
                    method: "post",
                    url: connect.url + "lists.element.get",
                    data: qs.stringify(ajaxParams,{ delimiter: '&'})
                }).then(result => {
                    resolve(result.data.result);
                });

            })
        })
    }

    loadProduct(arXMLId)
    {
        return new Promise((resolve, reject) => {
            this.getConnect(isDev).then(connect => {

                let ajaxParams = {
                    filter: {
                        'XML_ID': arXMLId
                    }
                };

                if (connect.auth) {
                    ajaxParams.auth = connect.auth.ACCESS_TOKEN;
                }
                // console.log(ajaxParams);
                // сохраняем
                axios({
                    method: "post",
                    url: connect.url + "crm.product.list",
                    data: qs.stringify(ajaxParams,{ delimiter: '&'})
                }).then(result => {

                    const total = result.data.total;

                    if (total <= 50) {
                        resolve(result.data.result);
                        return;
                    }

                    let cmd = []

                    for (let i = 0; i < total; i += 50) {
                        ajaxParams.start = i
                        cmd.push("crm.product.list?" + qs.stringify(ajaxParams,{ delimiter: '&'}))
                    }

                    this.getBatch(cmd).then(out => {
                        resolve(out)
                    })

                });

            })
        })
    }

    loadCatalogSection()
    {
        return new Promise((resolve, reject) => {
            this.getConnect(isDev).then(connect => {

                let ajaxParams = {
                    order: { "NAME": "ASC" }
                };

                if (connect.auth) {
                    ajaxParams.auth = connect.auth.ACCESS_TOKEN;
                }
                // console.log(ajaxParams);
                // сохраняем
                axios({
                    method: "post",
                    url: connect.url + "crm.productsection.list",
                    data: qs.stringify(ajaxParams,{ delimiter: '&'})
                }).then(result => {

                    const total = result.data.total;
                    let cmd = []

                    for (let i = 0; i < total; i += 50) {
                        ajaxParams.start = i
                        cmd.push("crm.productsection.list?" + qs.stringify(ajaxParams,{ delimiter: '&'}))
                    }

                    this.getBatch(cmd).then(out => {
                        resolve(out)
                    })

                });

            })
        })
    }

    loadCatalogProduct(sectionId)
    {
        return new Promise((resolve, reject) => {
            this.getConnect(isDev).then(connect => {

                let ajaxParams = {
                    order: { "NAME": "ASC" },
                    filter: {
                        'SECTION_ID': sectionId,
                    }
                };

                if (connect.auth) {
                    ajaxParams.auth = connect.auth.ACCESS_TOKEN;
                }
                // console.log(ajaxParams);
                // сохраняем
                axios({
                    method: "post",
                    url: connect.url + "crm.product.list",
                    data: qs.stringify(ajaxParams,{ delimiter: '&'})
                }).then(result => {

                    const total = result.data.total;

                    if (total <= 50) {
                        resolve(result.data.result);
                        return;
                    }

                    let cmd = []

                    for (let i = 0; i < total; i += 50) {
                        ajaxParams.start = i
                        cmd.push("crm.product.list?" + qs.stringify(ajaxParams,{ delimiter: '&'}))
                    }

                    this.getBatch(cmd).then(out => {
                        resolve(out)
                    })

                });

            })
        })
    }

    loadCatalogProductSearch(search)
    {
        return new Promise((resolve, reject) => {
            this.getConnect(isDev).then(connect => {

                let ajaxParamsName = {
                    filter: {
                        '%NAME': search,
                    }
                };
                let ajaxParamsCode = {
                    filter: {
                        '%PROPERTY_174': search
                    }
                };
                let ajaxParams = {
                    cmd: {
                        name: 'crm.product.list?' + qs.stringify(ajaxParamsName,{ delimiter: '&'}),
                        code: 'crm.product.list?' + qs.stringify(ajaxParamsCode,{ delimiter: '&'})
                    }
                };

                if (connect.auth) {
                    ajaxParams.auth = connect.auth.ACCESS_TOKEN;
                }
                // console.log(ajaxParams);
                // сохраняем
                axios({
                    method: "post",
                    url: connect.url + "batch",
                    data: qs.stringify(ajaxParams,{ delimiter: '&'})
                }).then(batch => {

                    let result = []

                    const totalName = batch.data.result.result_total.name
                    const totalCode = batch.data.result.result_total.code

                    let cmd = []

                    if (totalName <= 50) {
                        result = result.concat(batch.data.result.result.name);
                    } else {
                        for (let i = 0; i < totalName; i += 50) {
                            ajaxParamsName.start = i
                            cmd.push("crm.product.list?" + qs.stringify(ajaxParamsName,{ delimiter: '&'}))
                        }
                    }

                    if (totalCode <= 50) {
                        result = result.concat(batch.data.result.result.code);
                    } else {
                        for (let i = 0; i < totalCode; i += 50) {
                            ajaxParamsName.start = i
                            cmd.push("crm.product.list?" + qs.stringify(ajaxParamsCode,{ delimiter: '&'}))
                        }
                    }

                    if (cmd.length > 0) {
                        this.getBatch(cmd).then(out => {
                            resolve(result.concat(out))
                        })
                    } else {
                        resolve(result)
                    }

                });

            })
        })
    }

    addDeal(fields) {
        return new Promise((resolve, reject) => {
            this.getConnect(isDev).then(connect => {

                fields.TITLE = 'Новая сделка';

                let ajaxParams = {
                    fields,
                    params: {
                        'REGISTER_SONET_EVENT': 'Y'
                    }
                };

                if (connect.auth) {
                    ajaxParams.auth = connect.auth.ACCESS_TOKEN;
                }
                // console.log(ajaxParams);
                // сохраняем
                axios({
                    method: "post",
                    url: connect.url + "crm.deal.add",
                    data: qs.stringify(ajaxParams,{ delimiter: '&'})
                }).then(result => {

                    resolve(result.data.result)

                });

            })
        })
    }

    updateDeal(dealId, fields) {
        return new Promise((resolve, reject) => {
            this.getConnect(isDev).then(connect => {

                let ajaxParams = {
                    id: dealId,
                    fields,
                    params: {
                        'REGISTER_SONET_EVENT': 'Y'
                    }
                };

                if (connect.auth) {
                    ajaxParams.auth = connect.auth.ACCESS_TOKEN;
                }
                // console.log(ajaxParams);
                // сохраняем
                axios({
                    method: "post",
                    url: connect.url + "crm.deal.update",
                    data: qs.stringify(ajaxParams,{ delimiter: '&'})
                }).then(result => {

                    resolve(result.data.result)

                });

            })
        })
    }

    /**
     * @param {string} dealId
     * @param {array} rows { PRODUCT_ID: number, PRODUCT_NAME: string, QUANTITY: number, PRICE: string, TAX_RATE: number, TAX_INCLUDE: string }
     * */
    saveDealProduct(dealId, rows = []) {
        return new Promise((resolve, reject) => {
            this.getConnect(isDev).then(connect => {

                let ajaxParams = {
                    id: dealId,
                    rows,
                };

                if (connect.auth) {
                    ajaxParams.auth = connect.auth.ACCESS_TOKEN;
                }
                // console.log(ajaxParams);
                // сохраняем
                axios({
                    method: "post",
                    url: connect.url + "crm.deal.productrows.set",
                    data: qs.stringify(ajaxParams,{ delimiter: '&'})
                }).then(result => {

                    resolve(result.data.result)

                });

            })
        })
    }

    getBatch(cmd) {
        return new Promise((resolve, reject) => {
            this.getConnect(isDev).then(connect => {

                let ajaxParams = {
                    cmd: cmd.splice(0, 50)
                }
                if (connect.auth) {
                    ajaxParams.auth = connect.auth.ACCESS_TOKEN;
                }

                axios({
                    method: "post",
                    url: connect.url + "batch",
                    data: qs.stringify(ajaxParams,{ delimiter: '&'})
                }).then(batch => {
                    const result = batch.data.result.result

                    let list = [];

                    result.map(item => {
                        list = list.concat(item)
                    })

                    if (cmd.length > 0) {
                        this.getBatch(cmd).then(out => {
                            resolve(list.concat(out))
                        })
                    } else {
                        resolve(list)
                    }

                });
            })
        })
    }

    getConnect(isDev)
    {
        return new Promise((resolve, reject) => {
            let result = {};
            if (isDev) {
                result.url = urlDev;
                result.auth = null;
                resolve(result);
            } else {
                bx24.getAuth().then(auth => {
                    result.url = baseUrl + '/rest/';
                    result.auth = auth;
                    resolve(result);
                });
            }
        });
    }
}